import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { SortColumns, TabKey } from './-constants';
export const SearchSchema = z.object({
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum(SortColumns).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z.nativeEnum(TabKey).default(TabKey.ALL),
  freeText: z.string().optional()
});
export type SearchSchema = z.infer<typeof SearchSchema>;